import styled from 'styled-components';
import {Eye} from "assets/images";
import Scrollbars from "react-custom-scrollbars";

export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  padding: 63px 0 54px;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  background-color: rgba(251, 255, 251, 1);
  overflow-x: auto;
  textarea:focus, input:focus {
    outline: none;
  }
`;

export const SubmitDiv = styled.div`
  display: flex;
  justify-content: flex-end;
`;
export const AuthInput = styled.input`
  height: 56px;
  width: 329px;
  margin-top: 10px;
  padding-left: 12px;
  border-radius: 10px;
  padding-top: 14px;


  box-shadow: 0 0 7px rgba(0, 0, 0, 0.12), 0 0 0 rgba(0, 0, 0, 0.24);
`;

export const ShowPassword = styled(Eye)`
  cursor: pointer;
  position: absolute;
  right: 9px;
  top: calc(50% - 4px);
`;

export const ScrollWrapper = styled(Scrollbars)`
  height: 60px;
`
